<template>
  <div class="main-container">
    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
      <div>
        <vk-offcanvas-close @click="showOffCanvas = false"></vk-offcanvas-close>
        <div
          class="row"
          style="display: flex; justify-content: space-between; align-items: center;"
        >
          <h3 style="flex: 1;">{{selectedPackage?selectedPackage.name.toUpperCase():'-'}}</h3>
          <span>
            <el-button
              v-if="(offCanvasType == 'component_type')"
              size="md"
              variant="primary"
              @click="showAddModal = true"
            >
              Add component type&nbsp;
              <span class="fa fa-plus"></span>
            </el-button>
            <el-button v-else size="md" variant="primary" @click="showAddInventoryModal = true">
              Add inventory&nbsp;
              <span class="fa fa-plus"></span>
            </el-button>
          </span>
        </div>
        <hr style="margin: 0px !important;" />
        <Center v-if="(itemData.length < 1 && gettingPackage == false)">
          <span class="fa fa-ban fa-4x"></span>
          {{offCanvasType=="inventory_data"? "No inventory item":"No Component Type"}}
        </Center>
        <Center v-if="(itemData.length < 1 && gettingPackage == true)">
          <span class="fa fa-hourglass fa-4x animated infinite rotateIn"></span>
          {{offCanvasType=="inventory_data"? "Fetching inventory items":"Fetching Component Types"}}
        </Center>
        <!-- <ul v-if="(offCanvasType == 'component_type')">
            <li v-for="(_package,index) in itemData" :key="index" style="margin:12px 5px;">
              <div class="component_list_left">
               {{selectedPackage.name}} - {{_package["name"]?_package["name"]:`--`}}
        <b>{{_package}}</b>-->
        <!-- <h4>{{_package["componentType"]["name"]}}</h4> -->
        <!-- </div> -->
        <!-- <i class="fa fa-times-circle fa-2x" @click="deleteComponentConfig(_package['id'])"></i> -->
        <!-- </li>
        </ul>-->
        <template v-if="(offCanvasType == 'component_type')">
          <div style="width: 100%;margin-top:20px;" v-if="(itemData.length >= 1)">
            <el-input
              style="max-width: 200px"
              placeholder="Type something"
              prefix-icon="el-icon-search"
              v-model="search"
            ></el-input>
            <vue-good-table
              :columns="componentFields"
              :rows="itemData"
              :search-options="{enabled: true,
                externalQuery: search}"
              :pagination-options="{enabled: true}"
              :lineNumbers="true"
              styleClass="table table-striped col-md-8"
            >
              <template slot="table-row" slot-scope="props">
                <span class="nameStyle" v-if="props.column.field == 'name'">
                  {{ props.row.name? props.row['name']:'--' }}
                  <ReorderLevelAlert :itemRow="props.row" :inventories="currentInventories" />
                </span>
                <span
                  v-if="props.column.field == 'description'"
                >{{ props.row.description? props.row['description']:'--' }}</span>
                <span v-if="props.column.field == 'reorderLevel'">
                  {{ props.row.reorderLevel? props.row['reorderLevel'] : 0 }}
                  <button
                    type="button"
                    class="reorderLevelStyle"
                    @click="editReorderButton(props.row)"
                  >
                    <i class="fa fa-pencil"></i>
                  </button>
                </span>
                <span v-if="props.column.field == 'actions'" class="fancy">
                  <el-button
                    size="mini"
                    type="danger"
                    plain
                    @click="handleComponentTypeDelete(props.$index,props.row)"
                  >Delete</el-button>
                </span>
              </template>
              <template slot="pagination-bottom" slot-scope="props">
                <grey-pagination
                  :total="props.total"
                  :pageChanged="props.pageChanged"
                  :perPageChanged="props.perPageChanged"
                ></grey-pagination>
              </template>
            </vue-good-table>
          </div>
        </template>
        <template v-else>
          <div style="width: 100%;margin-top:20px;" v-if="(itemData.length >= 1)">
            <el-input
              style="max-width: 200px"
              placeholder="Type something"
              prefix-icon="el-icon-search"
              v-model="search"
            ></el-input>
            <vue-good-table
              :columns="inventoryFields"
              :rows="itemData"
              :search-options="{enabled: true,
                externalQuery: search}"
              :pagination-options="{enabled: true}"
              :lineNumbers="true"
              styleClass="table table-striped col-md-8"
            >
              <template slot="table-row" slot-scope="props">
                <span
                  v-if="props.column.field == 'name'"
                >{{ props.row.componentType.name? props.row.componentType.name:'--' }}</span>
                <span
                  v-if="props.column.field == 'serialNumber'"
                >{{ props.row.serialNumber? props.row['serialNumber']:'--' }}</span>
                <span
                  v-if="props.column.field == 'batchNumber'"
                >{{ props.row.batchNumber? props.row['batchNumber']:'--' }}</span>
                <span v-if="props.column.field == 'actions'" class="fancy">
                  <el-button
                    size="mini"
                    type="danger"
                    plain
                    @click="handleInventoryDelete(props.$index,props.row)"
                  >Delete</el-button>
                </span>
              </template>
              <template slot="pagination-bottom" slot-scope="props">
                <grey-pagination
                  :total="props.total"
                  :pageChanged="props.pageChanged"
                  :perPageChanged="props.perPageChanged"
                ></grey-pagination>
              </template>
            </vue-good-table>
          </div>
        </template>
        <!-- </el-card> -->
      </div>
    </vk-offcanvas>

    <el-form class="form" ref="form" :model="inventoryForm">
      <vk-modal :show.sync="showAddInventoryModal">
        <!-- <div style="text-align: center !important;"> -->
        <vk-modal-close @click="showAddInventoryModal = false"></vk-modal-close>
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <vk-modal-title>Add {{selectedPackage?selectedPackage.name:''}}</vk-modal-title>
          <span>
            <el-button size="sm" variant="primary" @click="multiple=!multiple">
              Add {{multiple?"Single":"Multiple" }}
              &nbsp;
              <span class="fa fa-plus"></span>
            </el-button>
          </span>
        </div>
        <hr />
        <!-- <img src="/static/img/modal/8.png" alt="" class="">
        <vk-modal-title>Add Inventory</vk-modal-title>
        </div>-->
        <div class="d-block text-center">
          <el-form-item class="form-item">
            <el-select
              style="flex: 1; width: 100%;"
              placeholder="Select Component Type"
              v-model="inventoryForm.componentTypeId"
            >
              <el-option
                v-for="item in componentTypeOptions"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- <el-button
              v-if="inventoryForm.componentTypeId"
              @click="generateSample"
              type="btn-primary-outline"
            >Download Sample</el-button>-->
          </el-form-item>
          <el-form-item v-if="!multiple" class="form-item">
            <el-input placeholder="Batch Number" type="text" v-model="inventoryForm.batchNumber"></el-input>
          </el-form-item>
          <!-- <el-form-item v-if="multiple" class="form-item">
            <el-input placeholder="Mininum Serial No" type="text" v-model="serialForm.min"></el-input>
          </el-form-item>-->
          <el-form-item v-if="multiple" class="form-item">
            <input style="background: #fff;" type="file" ref="input" @change="readFile" />
            <br />
            <progress style="width: 100%" max="100" :value.prop="uploadPercentage"></progress>
            <br />
            <span>{{uploadStatus}}</span>
          </el-form-item>
          <el-form-item v-else class="form-item">
            <el-input
              placeholder="Serial Number"
              id="inventoryForm_batch"
              type="text"
              v-model="inventoryForm.serialNumber"
            ></el-input>
          </el-form-item>

          <el-button size class="btn btn-primary" @click="addInventory" style="margin-top: 12px;">
            Add &nbsp;
            <span class="fa fa-plus"></span>
          </el-button>
        </div>
      </vk-modal>

      <!-- edit reorder level -->
      <EditReorderLevelComponent
        :showReorderEditModal="showReorderEditModal"
        :reorderItemRow="reorderItemRow"
        :defaultValue="reorderItemRow && reorderItemRow.reorderLevel ? reorderItemRow.reorderLevel : 0"
        @closeModal="closeEditReorderLevelModal"
        @updateCallback="reorderLevelUpdateResponse"
      />
    </el-form>
    <!-- <b-modal centered  ref="myModalRef" hide-footer no-close-on-backdrop size="lg" class="modal-md modal-content" role="document">
    <div slot="modal-header" style="text-align: center !important;">
      <b-btn class="close custom-modal__close" style="justify-content: center !important; font-size: .89em;" @click="hideModal"> <span aria-hidden="true" class="fa fa-close"></span></b-btn>
      <img src="/static/img/modal/8.png" alt="" class="">
      <h2 class="page-content__header-description">Add Inventory</h2>
    </div>

    <div class="d-block text-center">
      <div class="col-md-12" style="flex-flow: column; display: flex;">
        <b-form-select v-model="componentForm.componentId" :options="componentOptions" @change="fetchComponentTypes" placeholder="Select Component" class="mb-3" style="text-transform: capitalize !important">
        </b-form-select>
        <b-form-select v-model="componentForm.componentTypeId" :options="componentTypeOptions" placeholder="Select Component" class="mb-3" style="text-transform: capitalize !important">
        </b-form-select>
        <div style="width:100%">
        <div v-if="multiple"  style="width:90%;float:left">
          <input type="text" class="form-control col-md-6"  v-model="serialForm.min" placeholder="Mininum Serial No">
          <input type="text" class="form-control col-md-6"  v-model="serialForm.max" placeholder="Maximum Serial No">
        </div>
        <div v-else style="width:90%;float:left">
          <input type="text" class="form-control form-control-lg" id="componentForm_batch" v-model="componentForm.serialNumber" placeholder="Serial Number">
        </div>
        <div style="width:9%;float:left">
          <b-button class="form-control btn btn-primary"  @click="multiple=!multiple">
          &nbsp; <span class="fa fa-clone"></span>
        </b-button>
        </div>
        </div>
        <b-button size="" class="btn btn-primary" @click="addInventory" style="margin-top: 12px;">
          Add &nbsp; <span class="fa fa-plus"></span>
        </b-button>
      </div>
    </div>
    </b-modal>-->
    <el-form class="form" ref="form" :model="componentForm" label-width="120px">
      <vk-modal :show.sync="showAddModal">
        <vk-modal-close @click="showAddModal = false"></vk-modal-close>

        <vk-modal-title>Add Component Type</vk-modal-title>
        <!-- {{componentForm}} -->
        <el-form-item class="form-item" label="Name">
          <el-input placeholder="Name" type="text" v-model="componentForm.name"></el-input>
        </el-form-item>
        <el-form-item class="form-item" label="Description">
          <el-input placeholder="Description" type="text" v-model="componentForm.description"></el-input>
        </el-form-item>
        <el-form-item class="form-item" label="Unit">
          <el-input placeholder="Unit" type="text" v-model="componentForm.unit"></el-input>
        </el-form-item>
        <el-form-item class="form-item" label="Rating">
          <el-input placeholder="Rating" type="text" v-model="componentForm.rating"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="customer-btn" @click="submitComponentForm()">Create</el-button>
        </el-form-item>
      </vk-modal>
    </el-form>

    <div style="width: 100%;">
      <el-input
        style="max-width: 200px"
        placeholder="Type something"
        prefix-icon="el-icon-search"
        v-model="searchTerm"
      ></el-input>
      <!-- {{selectedPackage}} -->

      <vue-good-table
        :columns="tableFields"
        :rows="componentData"
        :search-options="{enabled: true,
          externalQuery: searchTerm}"
        :pagination-options="{enabled: true}"
        :lineNumbers="true"
        styleClass="table table-striped col-md-12"
      >
        <template slot="table-row" slot-scope="props">
          <span class="nameStyle" v-if="props.column.field == 'name'">
            {{ props.row.name? props.row.name :'--' }}
          </span>
          <span
            v-if="props.column.field == 'number'"
          >{{ props.row.inventories? props.row['inventories'].length:'--' }}</span>
          <span v-if="props.column.field == 'actions'" class="fancy">
            <can I="manage" a="installation">
              <el-button
                size="mini"
                type="primary"
                @click="viewComponentType(props.row)"
              >Component Type</el-button>
              <el-button size="mini" type="success" @click="viewInventory(props.row)">Inventory</el-button>
              <el-button
                size="mini"
                type="warning"
                @click="addBtnInventory(props.row)"
              >Add Inventory</el-button>
            </can>
          </span>
        </template>
        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
    <!-- </b-card> -->
    <!-- </div> -->
  </div>
</template>

<script>
/* eslint-disable */
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Table,
  TableColumn,
  Input,
  Upload
  // ...
} from "element-ui";
import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import { Modal, ModalClose, ModalTitle } from "vuikit/lib/modal";
import { mapGetters, mapActions } from "vuex";
import Papa from "papaparse";
import moment from "moment";
import {
  EditReorderLevelComponent,
  ReorderLevelAlert
} from "../kitchen/ArnergyInventoryComponents/index";
moment.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

const items = [];
export default {
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "vk-modal-title": ModalTitle,
    "vk-modal": Modal,
    "vk-modal-close": ModalClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-table": Table,
    "el-table-column": TableColumn,
    "el-input": Input,
    EditReorderLevelComponent,
    ReorderLevelAlert,
    "el-upload": Upload
  },
  data() {
    return {
      uploadStatus: "",
      uploadPercentage: 0,
      gettingPackage: false,
      showReorderEditModal: false,
      reorderItemRow: {
        reorderItemRow: 0
      },
      currentInventories: {},
      offCanvasType: "",
      search: "",
      searchTerm: "",
      responseData: "",
      componentName: "",
      selectedPackage: null,
      showAddModal: false,
      showOffCanvas: false,
      itemData: [],
      showAddInventoryModal: false,
      multiple: true,
      inventoryForm: {
        batchNumber: "",
        componentId: null,
        componentTypeId: null,
        serialNumber: "",
        type: "component",
        userId: 0
      },
      csvData: [],
      serialForm: {
        min: null,
        max: null
      },
      componentForm: {
        componentId: null,
        name: null,
        description: null,
        rating: null,
        unit: null,
        inStock: true
      },
      componentTypeOptions: [
        {
          value: null,
          disabled: true,
          text: "Select component type"
        }
      ],
      componentOptions: [
        {
          value: null,
          disabled: true,
          text: "Select component"
        }
      ],
      itemComponentData: [],
      items: items,
      inventoryFields: [
        {
          label: "Name",
          key: "name",
          field: "name",
          sortable: "true"
        },
        {
          label: "Serial Number",
          key: "serialNumber",
          field: "serialNumber",
          sortable: "true"
        },
        {
          label: "Batch Number",
          key: "batchNumber",
          field: "batchNumber",
          sortable: "true"
        },
        {
          label: "Actions",
          field: "actions"
        }
      ],
      componentFields: [
        {
          label: "Name",
          key: "name",
          field: "name",
          sortable: "true"
        },
        {
          label: "Description",
          key: "description",
          field: "description",
          sortable: "true"
        },
        {
          label: "Reorder Level",
          key: "reorderLevel",
          field: "reorderLevel",
          sortable: "true"
        },
        {
          label: "Actions",
          field: "actions"
        }
      ],
      tableFields: [
        {
          label: "Name",
          key: "name",
          field: "name",
          sortable: "true"
        },
        {
          label: "Number",
          key: "number",
          field: "number",
          sortable: "true"
        },
        {
          label: "Actions",
          field: "actions"
        }
      ],
      currentPage: 1,
      details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: { title: "", content: "" },
      componentData: [],
      componentTypeData: []
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {
    ...mapGetters([
      "getUserById",
      "getDeviceById",
      "getUsers",
      "getDummy",
      "getDevices",
      "getUserSession"
    ]),
    sortOptions() {
      // Create an options list from our fields
      return this.tableFields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    readFile() {
      var vm = this;
      let file = vm.$refs.input.files[0];
      // console.log(file);
      if (file.type === "text/csv") {
        let reader = new FileReader();
        var result = [];
        this.csvData = result;
        reader.readAsText(file);
        var csvToArray = function(csv) {
          var lines = csv.split("\n");
          // console.log(lines);
          var headers = lines[0].split(",");
          // console.log(headers);
          for (var i = 1; i < lines.length; i++) {
            var obj = {};
            var currentline = lines[i].split(",");
            for (var j = 0; j < headers.length; j++) {
              obj[headers[j]] = currentline[j];
            }
            result.push(obj);
          }
          // console.log(result);
        };
        // console.log(result);
        this.csvData = result;
        console.log(this.csvData);
        reader.onload = function() {
          // console.log(reader.result);
          var data = reader.result;
          csvToArray(data);
        };
        reader.onerror = function() {
          console.log(reader.error);
        };
      } else {
        this.showErrorMsg({
          message: "Please upload a CSV file!"
        });
      }
    },
    // handlePictureCardPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    // },
    generateSample() {
      // Papa
      let fields = ["serialNumber", "componentId", "componentTypeId", "userId"];
      let data = [
        [
          "",
          this.inventoryForm.componentId,
          this.inventoryForm.componentTypeId,
          0
        ]
      ];
      var CSV = Papa.unparse({
        fields,
        data
      });
      // console.log(csv)

      var fileName = "sample";

      var uri = "data:text/csv;charset=utf-8," + escape(CSV);

      var link = document.createElement("a");

      link.href = uri;

      link.style = "visibility:hidden";
      link.download = fileName + ".csv";

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);
    },
    fetchComponentTypes(selectedRowId) {
      // console.log(selectedRowId);
      this.componentTypeOptions = [];
      const context = this;
      const HTTP = this.$httpUtils.instance;
      const url = `/components/${selectedRowId}/componentTypes`;
      HTTP.get(url).then(response => {
        const componentList = response.data;
        componentList.filter(x => {
          x.value = x.id;
          x.text = x.name;
        });
        context.componentTypeOptions = [
          ...context.componentTypeOptions,
          ...componentList
        ];
        // console.log(context.componentTypeOptions);
      });
    },
    formatDate(date) {
      return moment(date).format("Do MMM YYYY");
    },
    handleComponentTypeDelete(index, row) {
      // console.log(index, row);
      const container = this;
      const HTTP = this.$httpUtils.instance;
      const url = `/component_types/${row.id}`;
      HTTP.delete(url)
        .then(response => {
          container.showSuccessMsg({
            message: "1 component type deleted"
          });
          this.getPackage(row.componentId);
        })
        .catch(error => {
          container.showErrorMsg({
            message: "Error occured!"
          });
        });
    },
    handleInventoryDelete(index, row) {
      //console.log(index, row);
      const container = this;
      const HTTP = this.$httpUtils.instance;
      const url = `/inventories/${row.id}`;
      HTTP.delete(url)
        .then(response => {
          container.showSuccessMsg({
            message: "1 inventory deleted"
          });
          this.getComponentInventory(row.componentId);
        })
        .catch(error => {
          container.showErrorMsg({
            message: "Error occured!"
          });
        });
    },
    getPackage(id) {
      this.gettingPackage = true;
      this.itemData = [];
      const HTTP = this.$httpUtils.instance;
      //const url = `/components/${id}/inventories?filter={"where":{"status": "0"},"include": ["component","componentType"]}`;
      const url = `/components/${id}/componentTypes`;
      return HTTP.get(url)
        .then(response => {
          this.itemData = response.data;
          // console.log({ itemData: this.itemData });
          this.gettingPackage = false;
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    showModal() {
      this.$refs.myModalRef.show();
    },
    getComponentInventory(id) {
      this.gettingPackage = true;
      this.itemData = [];
      const HTTP = this.$httpUtils.instance;
      const url = `/components/${id}/inventories?filter={"where":{"status": "0"},"include": ["component","componentType"]}`;
      return HTTP.get(url)
        .then(response => {
          this.itemData = response.data;
          this.gettingPackage = false;
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    async onSubmit() {},
    viewComponentType(row) {
      // console.log(row);
      this.selectedPackage = row;
      this.offCanvasType = "component_type";
      this.showOffCanvas = true;
      this.componentForm.componentId = row.id;
      this.currentInventories = row.inventories;
      this.getPackage(row.id);
    },
    viewInventory(row) {
      // console.log(row);
      this.selectedPackage = row;
      this.showOffCanvas = true;
      this.offCanvasType = "inventory_data";
      this.componentForm.componentId = row.id;
      this.getComponentInventory(row.id);
    },
    addBtnInventory(row) {
      // console.log(row);
      this.selectedPackage = row;
      this.showAddInventoryModal = true;
      this.inventoryForm.componentId = this.selectedPackage.id;
      this.fetchComponentTypes(row.id);
    },
    navTo(user) {
      this.$router.push({ name: this.details, params: { userId: user } });
      // console.log(user);
    },
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    editReorderButton(item) {
      this.showReorderEditModal = true;
      this.reorderItemRow = item;
    },
    closeEditReorderLevelModal() {
      this.showReorderEditModal = false;
      this.reorderItemRow = null;
    },
    reorderLevelUpdateResponse(success) {
      if (success) {
        this.showInfoMsg({
          message: "Reorder Level Updated"
        });
        this.getComponents();
        this.getPackage(this.componentForm.componentId);
      } else {
        this.showErrorMsg({
          message: "something went wrong! please try again"
        });
      }
      this.closeEditReorderLevelModal();
    },
    // fetchUsers() {
    //   const HTTP = this.$httpUtils.instance;
    //   //  filter={"include": ["installations"]}
    //   const url = `/users?filter[include][installations]=deviceType`;
    //   HTTP.get(url)
    //     .then(response => {
    //       const usersList = response.data;
    //       this.$store.commit("saveUsers", usersList);
    //       // console.log(this.getUserById(1))
    //     })
    //     .catch(error => {
    //       console.log("error", error);
    //     });
    // },
    validateRequestForm() {
      for (let [field, value] of Object.entries(this.componentForm)) {
        if (value === null || value === "") {
          return "Please fill all fields!";
        }
      }
      return true;
    },
    random_num: dumm => {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal() {
      this.$refs.myModalRef.show();
    },
    getComponentName(param) {
      return this.componentOptions.filter(x => x.value == param)[0].name;
    },
    hideModal() {
      this.$refs.myModalRef.hide();
    },
    validateInventoryRequestForm() {
      for (let [field, value] of Object.entries(this.inventoryForm)) {
        if (value === null || value === "") {
          return "Please fill all fields!";
        }
      }
      return true;
    },
    addInventory() {
      let url = "/inventories";
      // let url = "";
      if (this.multiple) {
        this.inventoryForm = this.csvData.reduce((acc, current) => {
          let _tmpPayload = {
            ...this.inventoryForm,
            serialNumber: `${current["serialNumberFrom"]}->${current["serialNumberTo"]}`,
            batchNumber: current["packingListNumber"]
          };
          return [...acc, _tmpPayload];
        }, []);
        // this.inventoryForm.serialNumber = `${this.serialForm.min}->${this.serialForm.max}`;
        url = "/inventories/multiple";
        // url = "";
      }
      console.log({ inventoryForm: this.inventoryForm });
      // this.inventoryForm.map(data => console.log(data));
      if (this.validateInventoryRequestForm() === true) {
        this.inventoryForm.userId = this.getUserSession.id;
        const container = this;
        const HTTP = this.$httpUtils.instance;
        //   console.log({ Form: this.inventoryForm });
        this.inventoryForm.map(data => {
          HTTP.post(url, data, {
            onUploadProgress: function(progressEvent) {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100)
              );
              if (this.uploadPercentage > 0 && this.uploadPercentage <= 60){
                this.uploadStatus = "Uploading..."
              }else if (this.uploadPercentage > 60 && this.uploadPercentage <= 90){
                this.uploadStatus = "Almost done!..."
              }else if (this.uploadPercentage === 100){
                this.uploadStatus = "Upload Complete!"
              }else {
                this.uploadStatus = "Upload failed!"
              }

            }.bind(this)
          }).then(response => {
            console.log(response);

            // container.showSuccessMsg({
            //   message: container.multiple
            //     ? response.data.length + "\nComponent(s) Added"
            //     : "Item added!"
            // });
            container.showAddInventoryModal = false;
            container.getComponents();
          })
          .catch(error => {
              if (error.response) {
                var errorMsg = error.response.data.error.details.messages;
                var errTemp = [];
                var keyHooks = Object.keys(errorMsg);
                Object.values(errorMsg).map((x, index) => {
                  errTemp[index] = keyHooks[index] + " " + x[0];
                });
                errTemp = Object.values(errTemp).join("<br>");
                container.showErrorMsg({
                  message: errTemp
                });
              } else {
                container.showErrorMsg({
                  message: "Error occured!"
                });
              }
            });
        });

        //   HTTP.post(url, this.inventoryForm)
        //     .then(response => {
        //       container.showSuccessMsg({
        //         message: container.multiple
        //           ? response.data.length + "\nComponent(s) Added"
        //           : "Item added!"
        //       });
        //       container.showAddInventoryModal = false;
        //       container.getComponents();
        //     })
        //     .catch(error => {
        //       if (error.response) {
        //         var errorMsg = error.response.data.error.details.messages;
        //         var errTemp = [];
        //         var keyHooks = Object.keys(errorMsg);
        //         Object.values(errorMsg).map((x, index) => {
        //           errTemp[index] = keyHooks[index] + " " + x[0];
        //         });
        //         errTemp = Object.values(errTemp).join("<br>");
        //         container.showErrorMsg({
        //           message: errTemp
        //         });
        //       } else {
        //         container.showErrorMsg({
        //           message: "Error occured!"
        //         });
        //       }
        //     });
      } else {
        this.showErrorMsg({
          message: this.validateInventoryRequestForm()
        });
      }
    },
    submitComponentForm() {
      if (this.validateRequestForm() === true) {
        const container = this;
        const HTTP = this.$httpUtils.instance;
        const url = "/component_types";
        HTTP.post(url, this.componentForm)
          .then(response => {
            //console.log(JSON.stringify(response));
            container.showInfoMsg({
              message: "Component Type Added"
            });
            container.showAddModal = false;
            container.getComponents();
            container.getPackage(this.componentForm.componentId);
            // window.reload();
            // container.reqSuccess = true;
          })
          .catch(error => {
            console.log(error);
            if (error.response) {
              var errorMsg = error.response.data.error.details.messages;
              var errTemp = [];
              var keyHooks = Object.keys(errorMsg);
              Object.values(errorMsg).map((x, index) => {
                errTemp[index] = keyHooks[index] + " " + x[0];
              });
              errTemp = Object.values(errTemp).join("<br>");
              this.showErrorMsg({
                message: errTemp
              });
              this.inventoryForm = {
                batchNumber: "",
                componentId: null,
                componentTypeId: null,
                serialNumber: "",
                type: "component",
                userId: 0
              };
              this.serialForm = {
                min: null,
                max: null
              };
            } else {
              var errorMsg = error.Error;
              this.showErrorMsg({
                message: errorMsg
              });
            }
          });
      } else {
        this.showErrorMsg({
          message: this.validateRequestForm()
        });
      }
    },
    getComponents() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.get(`/components?filter={"include": ["inventories"]}`, {}).then(
        components => {
          //console.log(JSON.stringify(components.data))
          // container.rows = components.data;
          container.componentData = components.data;

          //${id}/inventories?filter={"where":{"status": "0"}
          container.componentData.filter(x => {
            x.value = x.id;
            x.text = x.name;
            x.inventories = x.inventories.filter(y => y.status == 0);
          });
          //var ComponentNo=[];
          // for (i of container.componentData){
          //   HTTP.get(`/components/${i.id}/inventories?filter={"where":{"status": "0"}}`, {}).then(componentNo => {
          //     i = componentNo.data.length;
          //   })
          // }

          // componentFetch.unshift({
          //   value: null,
          //   disabled: true,
          //   text: "Select Component"
          // });
          // container.componentOptions = componentFetch;
          //container.setAccessLocal(saveRole.join);
        }
      );
    }
    // getComponentTypes() {
    //   const HTTP = this.$httpUtils.instance;
    //   const container = this;
    //   HTTP.get(`/components/${selectedPackage.id}/componentTypes`, {}).then(components => {
    //     //console.log(JSON.stringify(components.data))
    //     // container.rows = components.data;
    //     container.componentTypeData = components.data;
    //     container.componentTypeData.filter(x => {
    //       x.value = x.id;
    //       x.text = x.name;
    //     });

    //     componentFetch.unshift({
    //       value: null,
    //       disabled: true,
    //       text: "Select Component"
    //     });
    //     container.componentOptions = componentFetch;
    //     // container.setAccessLocal(saveRole.join);
    //   });
    // }
  },
  mounted() {
    this.getComponents();
    //this.getPackage(params.id);
  }
};
</script>
<style lang="scss" scoped>
.card-title {
  font-size: 2.6rem;
}
table th,
table th span {
  font-size: 0.7em;
}
.widget_box {
  min-height: auto !important;
}
.pull-right {
  float: right;
}
.modal-header {
  border-bottom-left-radius: 50% 20%;
  border-bottom-right-radius: 50% 20%;
  background: #ecf2f6;
  /* height: 100px; */
}
.reorderLevelStyle {
  background: none;
  border: 0;
  color: #1a93ca;
}
.reorderLevelStyle:hover {
  border-bottom: 1px solid #1a93ca;
}
.nameStyle {
  display: flex;
  align-items: center;
}
.p__component_list {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  cursor: pointer;
  .component_list_left {
    display: flex;
    flex-flow: row;
    justify-content: space-evenly;
    align-items: left;
    flex: 1;
    h2 {
      font-size: 17px;
      text-transform: capitalize;
      flex: 1;
    }
    h4 {
      margin-left: 100px;
      flex: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/inventory/components.vue